import {
  FETCH_CONVERSIONS_BEGIN,
  FETCH_CONVERSIONS_SUCCESS,
  FETCH_CONVERSIONS_FAILURE
} from '../actions/conversionActions';

const initialState = {
  items: [],
  availableProducts: [],
  loading: false,
  error: null
};

export default function conversionReducer(state = initialState, action) {
  switch(action.type) {
    case FETCH_CONVERSIONS_BEGIN:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_CONVERSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.conversions,
        availableProducts: action.payload.availableProducts,
        totalItems: action.payload.totalItems,
      };

    case FETCH_CONVERSIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        items: []
      };

    default:
      return state;
  }
} 